/**
 * OSHE wishlist (browser-only, localStorage).
 * Future: merge with logged-in customer wishlist via customer metafield + app proxy
 * or Customer Account API — not theme AJAX to metafields.
 */
(function () {
  const STORAGE_KEY = 'oshe_wishlist';
  const CHANGE_EVENT = 'oshe:wishlist:change';

  const HEART_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" class="oshe-wishlist-btn__icon">' +
    '<path class="oshe-wishlist-btn__outline" d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3z" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
    '<path class="oshe-wishlist-btn__fill" d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3z" fill="currentColor" stroke="none"/>' +
    '</svg>';

  let refreshInProgress = false;

  function readStorage() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((h) => typeof h === 'string' && h.length > 0);
    } catch {
      return [];
    }
  }

  function writeStorage(handles) {
    const unique = [];
    handles.forEach((h) => {
      if (typeof h === 'string' && h.length && !unique.includes(h)) unique.push(h);
    });
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    } catch {
      /* private mode */
    }
    return unique;
  }

  function getWishlist() {
    return readStorage();
  }

  function setWishlist(handles) {
    const next = writeStorage(handles);
    dispatchChange(next);
    syncUi();
    return next;
  }

  function setWishlistSilent(handles) {
    const next = writeStorage(handles);
    syncUi();
    return next;
  }

  function isWishlisted(handle) {
    return getWishlist().includes(handle);
  }

  function toggleHandle(handle) {
    if (!handle) return getWishlist();
    const list = getWishlist();
    const idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    return setWishlist(list);
  }

  function dispatchChange(handles) {
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { handles } }));
  }

  function formatMoney(cents) {
    const amount = Number(cents) / 100;
    if (Number.isNaN(amount)) return '';
    return amount.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  }

  function syncButtons(handles) {
    const set = new Set(handles);
    document.querySelectorAll('[data-wishlist-btn][data-handle]').forEach((btn) => {
      const handle = btn.dataset.handle;
      const active = set.has(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncCount(handles) {
    const count = handles.length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      if (count > 0) {
        el.textContent = ` (${count})`;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });
  }

  function syncUi() {
    const handles = getWishlist();
    syncButtons(handles);
    syncCount(handles);
    return handles;
  }

  function onWishlistClick(event) {
    const btn = event.target.closest('[data-wishlist-btn]');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    toggleHandle(btn.dataset.handle);
    btn.blur();
  }

  function buildWishlistButton(handle, labelSuffix) {
    const label = labelSuffix ? ` ${labelSuffix}` : '';
    return (
      `<button type="button" class="oshe-wishlist-btn is-active" data-wishlist-btn data-handle="${escapeHtml(handle)}" aria-pressed="true" aria-label="Remove from wishlist${escapeHtml(label)}">` +
      HEART_SVG +
      '</button>'
    );
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function resolveImageSrc(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || '';
  }

  function sizeOptionPosition(product) {
    const options = product.options || [];
    for (let i = 0; i < options.length; i++) {
      if (String(options[i]).toLowerCase() === 'size') return i + 1;
    }
    return 0;
  }

  function variantSizeLabel(variant, sizePos) {
    let label = variant.title || '';
    if (sizePos === 1) label = variant.option1 || label;
    else if (sizePos === 2) label = variant.option2 || label;
    else if (sizePos === 3) label = variant.option3 || label;
    if (label === 'Default Title') label = 'Add';
    return label;
  }

  function buildQuickAdd(product) {
    const variants = product.variants || [];
    if (!variants.length) return '';

    const sizePos = sizeOptionPosition(product);
    const buttons = variants
      .map((variant) => {
        const sizeLabel = variantSizeLabel(variant, sizePos);
        const available = variant.available !== false;
        const unavailableClass = available ? '' : ' is-unavailable';
        const attrs = available
          ? `data-variant-id="${escapeHtml(String(variant.id))}"`
          : 'disabled aria-disabled="true"';
        return (
          `<button type="button" class="oshe-quick-add__size${unavailableClass}" ${attrs} aria-label="Quick Add ${escapeHtml(sizeLabel)}, ${escapeHtml(product.title)}">` +
          `${escapeHtml(sizeLabel)}` +
          `</button>`
        );
      })
      .join('');

    return (
      `<oshe-quick-add class="oshe-quick-add no-js-hidden">` +
      `<span class="oshe-quick-add__label">Quick Add</span>` +
      `<div class="oshe-quick-add__sizes">${buttons}</div>` +
      `</oshe-quick-add>`
    );
  }

  function buildCard(product) {
    const imgSrc = resolveImageSrc(product.featured_image || (product.images && product.images[0]));
    const secondSrc = resolveImageSrc(product.images && product.images[1]);
    const price =
      product.price_varies && product.price_min != null
        ? `From ${formatMoney(product.price_min)}`
        : formatMoney(product.price);
    const url = product.url || `/products/${product.handle}`;

    const mediaImgs =
      (imgSrc
        ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(product.title)}" loading="lazy" width="533" height="666" class="motion-reduce">`
        : '') +
      (secondSrc
        ? `<img src="${escapeHtml(secondSrc)}" alt="" loading="lazy" width="533" height="666" class="motion-reduce">`
        : '');

    return (
      `<li class="grid__item">` +
      `<div class="card-wrapper product-card-wrapper underline-links-hover">` +
      `<div class="card card--standard card--media">` +
      `<div class="card__inner ratio" style="--ratio-percent: 125%;">` +
      `<div class="card__media">` +
      `<div class="media media--transparent media--hover-effect">` +
      mediaImgs +
      `</div>` +
      buildWishlistButton(product.handle, product.title) +
      `</div>` +
      buildQuickAdd(product) +
      `<div class="card__content">` +
      `<div class="card__information">` +
      `<h3 class="card__heading">` +
      `<a href="${escapeHtml(url)}" class="full-unstyled-link">${escapeHtml(product.title)}</a>` +
      `</h3>` +
      `</div></div></div>` +
      `<div class="card__content">` +
      `<div class="card__information">` +
      `<h3 class="card__heading h5">` +
      `<a href="${escapeHtml(url)}" class="full-unstyled-link">${escapeHtml(product.title)}</a>` +
      `</h3>` +
      `<div class="card-information">` +
      `<div class="price"><span class="price-item price-item--regular">${escapeHtml(price)}</span></div>` +
      `</div></div></div></div></div></li>`
    );
  }

  async function fetchProduct(handle) {
    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('not found');
    return response.json();
  }

  async function refreshWishlistPage() {
    const page = document.querySelector('.oshe-wishlist-page');
    if (!page || refreshInProgress) return;

    const root = document.getElementById('oshe-wishlist-root');
    const grid = document.getElementById('oshe-wishlist-grid');
    const empty = document.getElementById('oshe-wishlist-empty');
    if (!root || !grid || !empty) return;

    refreshInProgress = true;

    try {
      let handles = getWishlist();

      if (!handles.length) {
        root.hidden = true;
        empty.hidden = false;
        grid.innerHTML = '';
        return;
      }

      const results = await Promise.allSettled(handles.map((h) => fetchProduct(h)));
      const validHandles = [];
      const cards = [];

      results.forEach((result, index) => {
        const handle = handles[index];
        if (result.status === 'fulfilled') {
          validHandles.push(handle);
          cards.push(buildCard(result.value));
        }
      });

      if (validHandles.length !== handles.length) {
        handles = setWishlistSilent(validHandles);
      }

      if (!handles.length) {
        root.hidden = true;
        empty.hidden = false;
        grid.innerHTML = '';
        return;
      }

      grid.innerHTML = cards.join('');
      empty.hidden = true;
      root.hidden = false;
      syncButtons(handles);
    } finally {
      refreshInProgress = false;
    }
  }

  function initWishlistPage() {
    const page = document.querySelector('.oshe-wishlist-page');
    if (!page) return;

    refreshWishlistPage();
    document.addEventListener(CHANGE_EVENT, () => {
      if (document.querySelector('.oshe-wishlist-page')) refreshWishlistPage();
    });
  }

  document.addEventListener('click', onWishlistClick, true);

  document.addEventListener('DOMContentLoaded', () => {
    syncUi();
    initWishlistPage();
  });

  window.OsheWishlist = {
    getWishlist,
    setWishlist,
    toggleHandle,
    isWishlisted,
    syncUi,
  };
})();
